export const StateConvertor: { [key: string]: string } = {
    nct: 'پیش نویس',
    act: 'پیش نویس',
    unp: 'در انتظار قرعه‌کشی',
    dft: 'پیش نویس',
}
